import { useQuery } from '@tanstack/react-query';
import {
  GetDetailWithdrawRequestEntity,
  WithdrawRequestService,
} from 'services/openapi';

import { RequestWithdrawQueryKeys } from '../constants';

export const useGetRequestWithdrawDetailQuery = (
  id: string,
  enabled = true,
) => {
  const queryKey = [RequestWithdrawQueryKeys.GET_DETAIL_REQUEST_WITHDRAW, id];

  const {
    isLoading,
    error,
    data,
    isError,
    isFetching,
    isLoadingError,
    refetch,
  } = useQuery<GetDetailWithdrawRequestEntity, Error>({
    queryKey,
    queryFn: () =>
      WithdrawRequestService.withdrawRequestControllerGetDetail(id),
    retry: 0,
    refetchOnWindowFocus: false,
    keepPreviousData: true,
    enabled: enabled && !!id,
  });

  return {
    isLoading,
    isLoadingError,
    isFetching,
    error,
    data,
    isError,
    queryKey,
    refetch,
  };
};
